import React, {useContext} from 'react'
import { useTranslation } from 'react-i18next'
import {Row, Col, Button} from 'reactstrap'
import styled from 'styled-components'
import inicial from 'img/iryo/inicial.png'
import inicialSuperior from 'img/iryo/inicial-superior.png'
import infinita from 'img/iryo/infinita.png'
import infinitaBistro from 'img/iryo/infinita-bistro.png'
import basicLuggage from 'img/iryo/basic-luggage'
import extraLuggage from 'img/iryo/extra-luggage'
import {currency} from 'i18n/config'
import {inicialGroup, inicialSuperiorGroup, infinitaGroup, infinitaBistroGroup, arrowPositions, colorClasses} from './classes'
import BistroModal from './bistro_modal'
import {isMobile} from 'react-device-detect'
import {scrollTo, scrollIntoView} from 'scroll-js'

const Panel = styled.div`
  position:relative;

  .header {
    background: ${props => colorClasses(props.product)};
    color: white;
    text-transform: uppercase;
  }

  .body {
    border: 4px solid ${props => colorClasses(props.product)};
    border-top: 0px;
  }

  .arrow {
    display: ${props => props.isMobile ? 'none' : 'block'};
    position: absolute;
    color: ${props => colorClasses(props.product)};
    bottom: 100%;
    left: ${props => arrowPositions(props.product)};
    margin-left: -1rem;
    width: 2rem;
    height: 1rem;
    overflow: hidden;
    border-right: 23px solid transparent;
    border-top: 23px solid transparent;
    border-left: 23px solid transparent;
    border-bottom: 23px solid;
  }
`

const ProductDetails = (props) => {
  const {
    selected,
    availability,
    specialRequests,
    availableFeatures,
    bistroModal,
    toggleBistroModal,
    product,
    luggagePenalty,
    priceLabel,
    onConfirmProduct,
    setBistroModal,
    setSelected,
    allergensList,
    onSelectMenuForAll,
    type,
    setOutbound,
    setInbound
  } = props
  const { i18n } = useTranslation()

  const productImage = (code) => {
    if (inicialGroup.includes(code)) {
      return inicial
    } else if (inicialSuperiorGroup.includes(code)) {
      return inicialSuperior
    } else if (infinitaGroup.includes(code)) {
      return infinita
    } else if (infinitaBistroGroup.includes(code)) {
      return infinitaBistro
    }
  }

  const addons_req = selected.product.items[0].addons_req

  const addonsData = addons_req.map((addon_id) => typeof addon_id !== "undefined" && availability.offer.travels[0].addons[addon_id])

  const snackAddon = addonsData.find((addon) => addon.product_code == 'SNCK_R')

  const requiredAddon = selected.product.items[0].addons_req[0]

  const addonsWithoutSnack = addonsData.filter((addon) => addon.product_code != 'SNCK_R')
  const addon = addonsWithoutSnack && addonsWithoutSnack[0]
  const addonText = addon && availability.offer.texts.find((text) => text.code == addon.product_code)

  const filteredSpecialRequests = addonText && specialRequests.filter((sr) => addonText.allowedSpecialRequests && addonText.allowedSpecialRequests[0].codes.includes(sr.code))

  const luggageFeatureCodes = ['BAGGAGE1', 'BAGGAGE2', 'BAGGAGE3', 'BAGGAGE4', 'BAGGAGE5', 'LUG_IF01_R']
  const luggageFeatures = availableFeatures && availableFeatures.filter((feature) => luggageFeatureCodes.includes(feature.code))
  const otherFeatures = availableFeatures && availableFeatures.filter((feature) => !luggageFeatureCodes.includes(feature.code))

  return (
    <Row>
      {addonText &&
        <BistroModal
          bistroModal={bistroModal}
          setBistroModal={setBistroModal}
          toggleBistroModal={toggleBistroModal}
          availability={availability}
          selected={selected}
          setSelected={setSelected}
          filteredSpecialRequests={filteredSpecialRequests}
          allergensList={allergensList}
          addon={addon}
          snackAddon={snackAddon}
          onSelectMenuForAll={onSelectMenuForAll}
          onConfirmProduct={onConfirmProduct}
        />
      }
      <Col>
        <Panel id="iryo-product-details" product={product && product.code} isMobile={isMobile} className="shadow mt-md-4 mb-md-2 bg-white mt-3 mb-0" >
          <div className="arrow">A</div>
          <div className="header d-flex justify-content-between py-3 px-4">
            <div className="text-uppercase">{i18n.t('iryo_train_module.features_title')}</div>
            <div style={{cursor: 'pointer'}} onClick={() => type == 'outbound' ? setOutbound(null) : setInbound(null)}><i className="fa fa-times"></i></div>
          </div>
          <div className="body p-4">
            <Row>
              <Col xs="12" md="9" className="order-2 order-md-1">
                <Row className="mb-3">
                  <Col xs="12" md="4" className="mb-3 mb-md-3">
                    {luggageFeatures && luggageFeatures.some(({code}) => ['BAGGAGE4', 'BAGGAGE5'].includes(code)) ? (
                      <img src={extraLuggage} className="w-100"/>
                    ) : (
                      <img src={basicLuggage} className="w-100"/>
                    )}
                  </Col>
                  <Col xs="12" md="8">
                    <Row className="row-cols-1 row-cols-lg-2">
                      {luggageFeatures && luggageFeatures.map(({code, name, description}) => {
                        return (
                          <Col key={code}>
                            <span className="text-uppercase fw-bold"><i className="fa fa-angle-right" aria-hidden="true"></i> {name}</span>
                            <p>
                              {description}
                            </p>
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <strong className="text-danger">{i18n.t('format:common.very_important')}:</strong> {i18n.t('iryo_train_module.luggage_limit_advert', {amount: currency(luggagePenalty)})}
                    <hr/>
                  </Col>
                </Row>
                <Row className="row-cols-1 row-cols-lg-3">
                  {otherFeatures && otherFeatures.map(({code, name, description}) => {
                    return (
                      <Col key={code}>
                        <span className="text-uppercase fw-bold"><i className="fa fa-angle-right" aria-hidden="true"></i> {name}</span>
                        <p>
                          {description}
                        </p>
                      </Col>
                    )
                  })}
                </Row>
              </Col>
              <Col xs="12" md="3" className="d-flex justify-content-center align-items-center border order-1 order-md-2 mb-3 mb-md-0">
                <div className="d-flex flex-column justify-content-center">
                  <div className="w-100 d-flex justify-content-center">
                    <img width="200" src={productImage(product.code)}/>
                  </div>
                  <span className="text-center p-3" style={{fontSize: '1.5em', fontWeight: 'bold'}}>{priceLabel(selected.product)}</span>

                  {infinitaBistroGroup.includes(product && product.code) ? (
                    <Button color="primary" onClick={() => setBistroModal(true)} className="text-uppercase w-100 px-4 py-2 rounded-5">{i18n.t('iryo_train_module.select_menu')}</Button>
                  ) : (
                    <Button color="primary" onClick={onConfirmProduct} className="bg-primary text-white text-uppercase w-100 px-4 py-2 rounded-5">{i18n.t('format:actions.select')}</Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Panel>
      </Col>
    </Row>
  )
}

export default ProductDetails
